import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { propertyAmenityApi } from '../api/propertyAmenity.api';
import { propertyAmenityKeys } from '../api/propertyAmenity.keys';

export function usePropertyAmenityList(params: any) {
  return useQuery({
    queryKey: propertyAmenityKeys.list(params),
    queryFn: () => propertyAmenityApi.list(params),
    placeholderData: keepPreviousData,
  });
}

export function usePropertyAmenityDetails(id: any) {
  return useQuery({
    queryKey: propertyAmenityKeys.detail(id),
    queryFn: () => propertyAmenityApi.getById(id),
    enabled: !!id,
  });
}
